import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import AbadEc from '@zillow/abad-ec-sdk';

import { IconClose, token, TextButton } from '@zillow/constellation';
import OffMarketContactAgentForm, {
    fetchAbadHtml,
    submitContact,
} from '@zillow/off-market-contact-agent-form';
import { UniversalAnalyticsContext } from '@zillow/universal-analytics-react';

import ResponsiveLightbox from './ResponsiveLightbox';
import { trackHmimhwContactDisplay } from '../utils/gaUtils';
import type { Property, Viewer } from '../types/@zillow-types/pongo';

const StyledResponsiveLightbox = styled(ResponsiveLightbox)`
    background-color: ${token('colors.white')};
    padding: 50px 20px;
`;

const StyledIconClose = styled(IconClose)`
    color: ${token('colors.gray600')};
    font-size: 18px;
    position: absolute;
    right: 20px;
    top: 20px;
`;

const StyledTextButton = styled(TextButton)`
    display: flex;
`;

interface ContactFormLightboxProps {
    property: Property;
    viewer: Viewer;
    setShowContactAgentForm: (newState: boolean) => void;
    zatlasEndpoint: string;
    surfaceId: string;
    placementId: string;
    isLightboxBackgroundLocked: boolean;
}

const ContactFormLightbox = ({
    property,
    viewer,
    setShowContactAgentForm,
    zatlasEndpoint,
    surfaceId,
    placementId,
    isLightboxBackgroundLocked,
}: ContactFormLightboxProps) => {
    const abadClient = AbadEc.abadClient({ productId: 'Z', appId: 'property-owner-components' });

    const { areRequiredDimensionsSet } = useContext(UniversalAnalyticsContext);
    useEffect(() => {
        if (areRequiredDimensionsSet) {
            trackHmimhwContactDisplay(surfaceId, placementId);
        }
    }, [areRequiredDimensionsSet, surfaceId, placementId]);
    return (
        <StyledResponsiveLightbox isLightboxBackgroundLocked={isLightboxBackgroundLocked}>
            <OffMarketContactAgentForm
                // @ts-expect-error property Type is not matched - fix in STL-4217
                property={property}
                // @ts-expect-error viewer Type is not matched - fix in STL-4217
                viewer={viewer}
                zatlasEndpoint={zatlasEndpoint}
                showCheckBox={false}
                centerAlignedNote
                page="hmimhw"
                location="sitelink-slot-1"
                abadClient={abadClient}
                onSubmit={async (params) => submitContact(params)}
                onFetchAbadHtml={async (params) => fetchAbadHtml(params)}
            />
            <StyledTextButton
                data-testid="contact-close-button"
                onClick={() => setShowContactAgentForm(false)}
                icon={<StyledIconClose />}
            />
        </StyledResponsiveLightbox>
    );
};

export default ContactFormLightbox;
